import apiClient from '@/services/axios'

export async function del(venueId, role, categoryId, todoId) {
  var response = await apiClient.delete(`/PersonalTodos/${venueId}/${role}/${categoryId}/${todoId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete personal todo.')
}